/* eslint-disable no-unused-expressions */
/* global G */
import { setKey } from 'lib/util'

/**
 * Onboarding Success Action
 *
 * Sets the route saved in the action state as the next route
 *
 * @param {Gaia.AppModule.Spec} module  the current module object
 * @returns {function(): function(*, ...[*]=): Promise<*[]>}
 */
// eslint-disable-next-line no-unused-vars
const actionFn = module => () => async (...args) => {
  const { route: nextRoute = null } = module[G.STATE][G.ACTION][G.STATE]

  if (!nextRoute) {
    throw new Error(`ERROR: next route was not defined. Got: ${nextRoute}`)
  } else {
    setKey(nextRoute, G.ROUTE, module[G.STATE])
  }

  return args
}

export default actionFn
